<template>
  <v-list-tile avatar @click="goTo()" ripple :class="!item.seen ? 'blue lighten-5': ''">
    <v-list-tile-avatar tile :color="$store.state.global.pages[item.type].color">
      <span class="white--text">{{item.type.charAt(0).toUpperCase()}}</span>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>{{item.title}}</v-list-tile-title>
      <v-list-tile-sub-title>
        <time-ago :time="item.time">
          <v-icon small color="grey lighten-1" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action v-if="!item.seen && !loading">
      <v-icon>priority_high</v-icon>
    </v-list-tile-action>
    <v-list-tile-action v-if="loading">
      <v-progress-circular indeterminate size="24" width="2" color="primary"></v-progress-circular>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import Api from "@/services/api";
import TimeAgo from "@/components/misc/timeAgo.vue";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    goTo() {
      //alert("Go to this "+this.item.type);
      var ids = JSON.stringify(this.item.ids);
      this.$router.push({ name: this.item.type, query: { ids: ids } });
      this.setRead();
      // this.loading = true
      // setTimeout(() => {
      //     this.loading = false
      //     this.close()
      // }, 1300);
    },
    setRead() {
      this.loading = true;
      Api.put(`notifications/setRead/1`)
        .then(result => {
          this.loading = false;
          this.close();
        })
        .catch(err => {
          console.log(err);
          //ERROR SNACK
          this.loading = false;
          this.close();
        });
    },
    close() {
      this.$emit("close");
    }
  },
  props: {
    item: Object
  },
  components: {
    TimeAgo
  }
};
</script>

<style>
</style>
